/* ================================================== */
/* PLUGINS → lazy load
/* ================================================== */

$(document).ready(function() {

	$('body.contact img.lazy')
		.attr('src', $('body.contact img.lazy').attr('data-original'))
		.removeAttr('data-original')
		.removeClass('lazy');

	$('.lazy').lazyload({
		placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
		threshold  : 400,
		container: ($('.projects-list').length) ? $('.projects-list') : $('body'),
		load       : function() {
			$(this).addClass('initialized');
		}
	});

});